import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get_category, edit_category, manage_sub_category, edit_sub_category, delete_sub_category } from "../../reduxData/user/userAction";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import { useTranslation } from "react-i18next";
import { languageFields } from "../../hooks/LanguageFields";

const CategoryDetails = ({ open, editCategory, currentPage, perPage, onClose, onSaved }) => {
  const { i18n , t } = useTranslation();
  const dispatch = useDispatch();
  const [catName, setCatName] = useState("");
  const [catName_nl, setCatName_nl] = useState("");
  const [isEditingCatName, setIsEditingCatName] = useState(false);
  const [catNameInput, setCatNameInput] = useState("");
  const [catNameInput_nl, setCatNameInput_nl] = useState("");
  const [subcategories, setSubcategories] = useState([]);
  const [editingSubId, setEditingSubId] = useState(null);
  const [editingSubName, setEditingSubName] = useState("");
  const [editingSubName_nl, setEditingSubName_nl] = useState("");
  const [newSubName, setNewSubName] = useState("");
  const [newSubName_nl, setNewSubName_nl] = useState("");
  const [category, setCategory] = useState(null);
  const { categoriesList, totalCategories } = useSelector((state) => state.user);

  // fetch categories data 
  const fetchCategories = async (currentPage, perPage) => {
    await get_category(dispatch, currentPage, perPage)
  };

  useEffect(() => {
    fetchCategories(currentPage, perPage);
  }, [currentPage, perPage]);

  // set if edit data 
  useEffect(() => {
    if (editCategory?.id && categoriesList?.length) {
      const foundCategory = categoriesList.find((item) => (item.id || item._id) === editCategory.id);
      if (foundCategory) {
        setCategory(foundCategory);
      }
    }
  }, [editCategory, categoriesList]);

  useEffect(() => {
    if (category) {
      setCatName(category.name || "");
      setCatName_nl(category.name_nl || "");
      setCatNameInput(category.name || "");
      setCatNameInput_nl(category.name_nl || "");
      setSubcategories(category.subcategories || []);
      setIsEditingCatName(false);
    }
  }, [category]);

  const handleStartEditCatName = () => {
    setCatNameInput(catName);
    setCatNameInput_nl(catName_nl);
    setIsEditingCatName(true);
  };

  // handle category name update 
  const handleSaveCategoryName = async () => {
    const data = await edit_category({ name: catNameInput, name_nl: catNameInput_nl }, category?.id, dispatch);
    if (data?.data?.status) {
      setCatName(catNameInput);
      setCatName_nl(catNameInput_nl);
      setIsEditingCatName(false);
      onSaved();
    }
  };

  // cencel category name update 
  const handleCancelEditCatName = () => {
    setCatNameInput(catName);
    setCatNameInput_nl(catName_nl);
    setIsEditingCatName(false);
  };

  // hanlde delete subcategory 
  const handleDeleteSub = async (sub) => {
    await delete_sub_category(sub.id, dispatch);
    setSubcategories((prev) =>
      prev.filter((s) => (s.id) !== (sub.id))
    );
    onSaved();
  };

  // open subcategory edit screen 
  const handleStartEditSub = (sub) => {
    setEditingSubId(sub.id);
    setEditingSubName(sub.name || "");
    setEditingSubName_nl(sub.name_nl || "");
  };

  // save edit sub category 
  const handleSaveEditSub = async (sub) => {
    const formData = new FormData();
    formData.append("name", editingSubName);
    formData.append("name_nl", editingSubName_nl);
    formData.append("category_id", category?.id);
    const res = await edit_sub_category(sub.id, formData, dispatch);
    if (res) {
      setSubcategories((prev) =>
        prev.map((s) =>
          (s.id || s._id) === sub.id
            ? {
              ...s,
              name: editingSubName,
              name_nl: editingSubName_nl,
            }
            : s
        )
      );
    }
    setEditingSubId(null);
    setEditingSubName("");
    setEditingSubName_nl("");
    onSaved();
  };

  // cancel edit subcategory screen 
  const handleCancelEditSub = () => {
    setEditingSubId(null);
    setEditingSubName("");
    setEditingSubName_nl("");
  };

  // handle add new subcategory 
  const handleAddNewSub = async () => {
    if (!newSubName.trim()) return;
    if (!newSubName_nl.trim()) return;
    const formData = new FormData();
    formData.append("name", newSubName);
    formData.append("name_nl", newSubName_nl);
    formData.append("category_id", category?.id);
    const data = await manage_sub_category(formData, dispatch);
    if (data) {
      const newSub = data?.data?.subcategory || {
        id: Date.now().toString(),
        name: newSubName,
        name_nl: newSubName_nl,
      };
      setSubcategories((prev) => [...prev, newSub]);
      setNewSubName("");
      setNewSubName_nl("");
      onSaved();
    }
  };
  const getTypeName = (typeId) => typeId || "—";
  if (!category) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog className="ec-modal">
        <div className="ec-header">
          <div>
            <h3>{t("categoryDetails.title")}</h3>
            <p>{t("categoryDetails.subtitle")}</p>
          </div>
          <button className="ec-close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="ec-body">
          <div className="ec-card">
            <div className="ec-card-header">{t("categoryDetails.categoryNameHeader")}</div>
            <div className="ec-card-body">
              {isEditingCatName ? (
                <div className="ec-cat-edit-row">
                  <div className="input-div">
                    <label>{t("categoryDetails.editCategoryNameLabel")}</label>
                    <input
                      className="ec-input"
                      value={catNameInput}
                      onChange={(e) => setCatNameInput(e.target.value)}
                      autoFocus
                    />
                  </div>
                  <div className="input-div">
                    <label>{t("categoryDetails.editCategoryNameNlLabel")}</label>
                    <input
                      className="ec-input"
                      value={catNameInput_nl}
                      onChange={(e) => setCatNameInput_nl(e.target.value)}
                      autoFocus
                    />
                  </div>
                  <button className="ec-btn ec-btn-save" onClick={handleSaveCategoryName}>
                    {t("categoryDetails.update")}
                  </button>
                  <button className="ec-btn ec-btn-cancel" onClick={handleCancelEditCatName}>
                    {t("categoryDetails.cancel")}
                  </button>
                </div>
              ) : (
                <div className="ec-cat-display">
                  <span className="ec-cat-name-text">{i18n.language=="en"?catName:catName_nl}</span>
                  <button className="ec-btn ec-btn-edit" onClick={handleStartEditCatName}>
                    {t("categoryDetails.edit")}
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="ec-card">
            <div className="ec-card-header">{t("categoryDetails.addNewSubCategoryHeader")}</div>
            <div className="ec-card-body">
              <div className="ec-add-row">
                <div className="input-div">
                  <label>{t("categoryDetails.subCategoryNameLabel")}</label>
                  <input
                    className="ec-input"
                    placeholder={t("categoryDetails.subNamePlaceholderExample")}
                    value={newSubName}
                    onChange={(e) => setNewSubName(e.target.value)}
                  />
                </div>
                <div className="input-div">
                  <label>{t("categoryDetails.subCategoryNameNlLabel")}</label>
                  <input
                    className="ec-input"
                    placeholder={t("categoryDetails.subNamePlaceholderExample")}
                    value={newSubName_nl}
                    onChange={(e) => setNewSubName_nl(e.target.value)}
                  />
                </div>
                <button
                  className="ec-btn ec-btn-primary"
                  onClick={handleAddNewSub}
                  disabled={!newSubName.trim() || !newSubName_nl.trim()}
                >
                  {t("categoryDetails.addButton")}
                </button>
              </div>
            </div>
          </div>
          <div className="ec-card">
            <div className="ec-card-header">
              {t("categoryDetails.existingSubCategoriesHeader")}
              <span className="ec-count">{subcategories.length}</span>
            </div>
            <div className="ec-card-body">
              {subcategories.length === 0 && (
                <p style={{ color: "#bbb", fontSize: 13, textAlign: "center", margin: "8px 0" }}>
                  {t("categoryDetails.noSubcategoriesYet")}
                </p>
              )}

              {subcategories.map((sub) => {
                const subId = sub.id || sub._id;
                const isEditing = editingSubId === subId;

                return (
                  <div className="ec-sub-item" key={subId}>
                    {isEditing ? (
                      <>
                        <div className="ec-edit-fields">
                          <div className="input-div">
                            <label>{t("categoryDetails.editSubCategoryNameLabel")}</label>
                            <input
                              className="ec-input"
                              value={editingSubName}
                              onChange={(e) => setEditingSubName(e.target.value)}
                              autoFocus
                            />
                          </div>
                          <div className="input-div">
                            <label>{t("categoryDetails.editSubCategoryNameNlLabel")}</label>
                            <input
                              className="ec-input"
                              value={editingSubName_nl}
                              onChange={(e) => setEditingSubName_nl(e.target.value)}
                              autoFocus
                            />
                          </div>
                        </div>
                        <div className="ec-item-actions">
                          <button
                            className="ec-btn ec-btn-save"
                            onClick={() => handleSaveEditSub(sub)}
                          >
                            {t("categoryDetails.save")}
                          </button>
                          <button
                            className="ec-btn ec-btn-cancel"
                            onClick={handleCancelEditSub}
                          >
                            {t("categoryDetails.cancel")}
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="ec-sub-chip">
                          <span className="ec-sub-chip-name">
                            {languageFields(sub, "name", i18n)}
                            {/* {sub.name} */}
                          </span>
                        </div>
                        <div className="ec-item-actions">
                          <button
                            className="ec-btn ec-btn-edit"
                            onClick={() => handleStartEditSub(sub)}
                          >
                            {t("categoryDetails.edit")}
                          </button>
                          <button
                            className="ec-btn ec-btn-delete"
                            onClick={() => handleDeleteSub(sub)}
                          >
                            {t("categoryDetails.delete")}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="ec-footer">
          <button className="ec-btn ec-btn-ghost" onClick={onClose}>
            {t("categoryDetails.close")}
          </button>
        </div>

      </ModalDialog>
    </Modal>
  );
};

export default CategoryDetails;

